import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GroupsUsersMgComponent } from "./groups-users-mg/groups-users-mg.component";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { MatIconModule } from "@angular/material/icon";
import { PipesModule } from "../pipes/pipes.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ComponentsMangoLayoutModule } from "../components/components.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatChipsModule } from "@angular/material/chips";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ToastrModule } from "ngx-toastr";
import { MatSelectModule } from "@angular/material/select";

@NgModule({
  declarations: [GroupsUsersMgComponent],
  imports: [
    CommonModule,
    NgxDatatableModule,
    MatIconModule,
    MatTooltipModule,
    PipesModule,
    ToastrModule,
    MatSelectModule,
    FormsModule,
    MatFormFieldModule,
    MatChipsModule,
    ComponentsMangoLayoutModule,
    ReactiveFormsModule,
  ],
  exports: [GroupsUsersMgComponent],
})
export class PagesCoreModule {}
